import {
  authenticatedGet,
  authenticatedPost,
  authenticatedPut,
  authenticatedDelete,
} from "../../../../api/authenticatedFetch";

const BASE = "/api/v1/scenarios";

// listScenarios returns the saved scenarios array (unwrapped).
export const listScenarios = async () => {
  const res = await authenticatedGet(BASE);
  return res && res.scenarios ? res.scenarios : res || [];
};

// createScenario persists a new named scenario; returns the created record.
export const createScenario = async ({ name, adjustments }) => {
  const res = await authenticatedPost(BASE, { name, adjustments });
  return res && res.scenario ? res.scenario : res;
};

// updateScenario updates an existing scenario by id.
export const updateScenario = async ({ id, name, adjustments }) =>
  authenticatedPut(`${BASE}/${id}`, { name, adjustments });

// deleteScenario removes a scenario by id.
export const deleteScenario = async (id) => authenticatedDelete(`${BASE}/${id}`);

// scoreScenario returns the baseline-vs-scenario score for the given levers (unwrapped result).
export const scoreScenario = async ({ period, adjustments }) =>
  authenticatedPost(`${BASE}/score`, { period, adjustments });
